import { Separator, XStack, YStack } from "tamagui";
import { Label, Title } from "./webSettingsDialog.styles";
import { useEffect, useState } from "react";
import "./styles.css";
import useBreakpoint from "@shane-collective/design-system/dist/hooks/useBreakpoint";
import { Button, primary1 } from "@shane-collective/design-system";

export const SettingsDialog = ({
  settings,
  onSubmit,
  onClose,
}: {
  settings: any;
  onSubmit: (newSettings: any) => void;
  onClose: () => void;
}) => {
  const [allSettings, setAllSettings] = useState<any>(settings);
  useEffect(() => {
    setAllSettings(JSON.parse(JSON.stringify(settings)));
  }, [settings]);

  const breakpoint: "xxxs" | "xxs" | "xss" | "xs" | "sm" | "md" | "lg" | "xl" =
    useBreakpoint();

  return (
    <YStack
      width={
        ["xxxs", "xxs", "xss", "xs", "sm"].includes(breakpoint)
          ? "100vw"
          : "400px"
      }
      rowGap={25}
      padding={20}
      borderRadius={10}
      height={"fit-content"}
    >
      <XStack justifyContent="space-between" width="100%" alignItems="baseline">
        <XStack justifyContent="center" width={"95%"}>
          <Title textAlign="center">Map settings</Title>
        </XStack>
        <Button
          type={"secondary_icon"}
          backgroundColor="transparent"
          padding={0}
          borderWidth={0}
          onPress={onClose}
          aria-label={"Close settings dialog"}
          iconName="CloseIcon"
          iconWidth="15px"
        />
      </XStack>

      <Separator />

      <YStack alignItems="flex-end" rowGap={10} id="mapSettings">
        {Object.keys(allSettings)
          .filter(
            (s) =>
              ![
                "gender",
                "orientation",
                "rememberProfile",
                "additionalGender",
                "genderId",
                "orientationId",
                "additionalGenderId",
              ].includes(s)
          )
          .map((setting) => (
            <SwitchWithLabel
              key={"switch-" + setting}
              onCheckedChange={(checked: boolean) => {
                setAllSettings({ ...allSettings, [setting]: checked });
              }}
              label={setting}
              value={allSettings[setting]}
            />
          ))}
      </YStack>
      <Button
        type="primary_small"
        onPress={() => onSubmit(allSettings)}
        aria-label={"Apply settings"}
        label="Apply"
      />
    </YStack>
  );
};

//!Couldn't get tamagui switch to render properly so changed this interface to web-only and manually creating my own switch
export function SwitchWithLabel(props: {
  onCheckedChange: (checked: boolean) => void;
  label: string;
  value: boolean;
}) {
  const id = `switch-${props.label ?? ""}}`;
  return (
    <XStack width={300} gap={10} justifyContent="flex-end" alignItems="center">
      <Label
        paddingRight="$0"
        minWidth={90}
        justifyContent="flex-end"
        htmlFor={id}
      >
        {props.label}
      </Label>
      <Switch onToggle={props.onCheckedChange} value={props.value} id={id} />
    </XStack>
  );
}

const Switch = ({
  onToggle,
  value,
  id,
}: {
  onToggle: (newState: boolean) => void;
  value: boolean;
  id: string;
}) => {
  // State to track whether the switch is active or not
  const [isActive, setIsActive] = useState(value);

  useEffect(() => {
    setIsActive(value);
  }, [value]);

  // Handle the toggle action
  const handleToggle = () => {
    onToggle(!isActive);
    setIsActive((prevState) => !prevState); // Toggle the state
  };

  return (
    <div
      id={id}
      className={`switch ${isActive ? "active" : ""}`} // Apply active class when isActive is true
      onClick={handleToggle} // Toggle on click
      style={{
        position: "relative",
        width: "60px",
        height: "30px",
        backgroundColor: isActive ? primary1 : "#ccc", // Green if active, gray if inactive
        borderRadius: "30px",
        cursor: "pointer",
        transition: "background-color 0.3s",
      }}
    >
      <div
        className="toggle"
        style={{
          position: "absolute",
          top: "4px",
          left: isActive ? "34px" : "4px", // Move the toggle to the right when active
          width: "22px",
          height: "22px",
          backgroundColor: "white",
          borderRadius: "50%",
          transition: "left 0.3s",
        }}
      ></div>
    </div>
  );
};
